import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Star,
  BookOpen,
  Trophy,
  MessageSquare,
  Award,
  BarChart3,
  Bell,
  User,
  CreditCard,
  Bot
} from 'lucide-react';

const SecondaryNav = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/dashboard',
      label: 'Tableau de bord',
      icon: User,
      description: 'Vue d\'ensemble'
    },
    {
      path: '/my-courses',
      label: 'Mes Cours',
      icon: BookOpen,
      description: 'Vos cours et progression'
    },
    {
      path: '/reviews',
      label: 'Avis',
      icon: Star,
      description: 'Lisez et donnez des avis'
    },
    {
      path: '/programs',
      label: 'Programmes',
      icon: BookOpen,
      description: 'Parcours d\'apprentissage'
    },
    {
      path: '/gamification',
      label: 'Gamification',
      icon: Trophy,
      description: 'Badges et classements'
    },
    {
      path: '/chat',
      label: 'Messages',
      icon: MessageSquare,
      description: 'Chat en temps réel'
    },
    {
      path: '/ai-assistant',
      label: 'Assistant IA',
      icon: Bot,
      description: 'Aide personnalisée par IA'
    },
    {
      path: '/certificates',
      label: 'Certificats',
      icon: Award,
      description: 'Vos certificats'
    },
    {
      path: '/subscription',
      label: 'Abonnements',
      icon: CreditCard,
      description: 'Gestion des abonnements'
    },
    {
      path: '/analytics',
      label: 'Analytics',
      icon: BarChart3,
      description: 'Statistiques avancées',
      adminOnly: true
    },
    {
      path: '/notifications',
      label: 'Notifications',
      icon: Bell,
      description: 'Centre de notifications'
    }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="hidden sm:block bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex space-x-1 sm:space-x-4 overflow-x-auto scrollbar-hide">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-1.5 px-2 sm:px-3 py-3 sm:py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  isActive(item.path)
                    ? 'border-primary text-primary dark:text-primary-400'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                }`}
                title={item.description}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="hidden md:inline">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default SecondaryNav;
